import { render, staticRenderFns } from "./DirectorCalculationBasis.vue?vue&type=template&id=bdaaa11c&scoped=true&"
import script from "./DirectorCalculationBasis.vue?vue&type=script&lang=ts&"
export * from "./DirectorCalculationBasis.vue?vue&type=script&lang=ts&"
import style0 from "./DirectorCalculationBasis.vue?vue&type=style&index=0&id=bdaaa11c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaaa11c",
  null
  
)

export default component.exports